import React from 'react';
import { Check } from '@finect/tabular-icons/check';
import { Verified, Label } from './partials';
export var OrganizationLabel = function OrganizationLabel(props) {
  var entity = props.product.entity;
  return React.createElement(Label, {
    href: entity && entity.web,
    title: "Ver ".concat(entity && entity.displayName)
  }, entity && entity.displayName || "", React.createElement(Verified, {
    size: 14,
    iconSize: 10,
    inverted: false
  }, React.createElement(Check, {
    size: 10,
    strokeWidth: 2
  })));
};